const config = {
  mainTitle: 'Insights',
  subHeading: 'A page to see cunstomers insights',
  titleIcon: 'IosBookmarksOutline'
}

export default config
